import { useEffect, useState } from 'react';
import { fetchViewCount } from '../utils/viewCountApi';

export function useViewCount(enabled) {
  const [viewCount, setViewCount] = useState(null);

  useEffect(() => {
    if (!enabled) {
      return undefined;
    }

    let cancelled = false;

    async function loadCount() {
      const count = await fetchViewCount();
      if (!cancelled && count !== null) {
        setViewCount(count);
      }
    }

    loadCount();

    return () => {
      cancelled = true;
    };
  }, [enabled]);

  return viewCount;
}
